import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { BookIcon, ClockIcon, TrophyIcon, BarChart2Icon, CheckCircleIcon } from 'lucide-react';
interface ExerciseCardProps {
  exercise: {
    title: {
      en: string;
      ar: string;
    };
    description: {
      en: string;
      ar: string;
    };
    difficulty: string;
    difficultyAr: string;
    type: string;
    typeAr: string;
    questions: number;
    timeEstimate: string;
    progress: number;
    streak?: number;
    isCompleted?: boolean;
  };
  onClick: () => void;
}
export function ExerciseCard({
  exercise,
  onClick
}: ExerciseCardProps) {
  const {
    isArabic
  } = useLanguage();
  return <div className="bg-white dark:bg-gray-800 rounded-xl shadow-md hover:shadow-lg transition-all duration-200 cursor-pointer group" onClick={onClick} data-id="element-330">
      <div className="p-6" data-id="element-331">
        {/* Header */}
        <div className="flex items-center justify-between mb-4" data-id="element-332">
          <div className="flex items-center gap-2" data-id="element-333">
            <div className={`
              p-2 rounded-lg
              ${exercise.difficulty === 'Beginner' ? 'bg-green-100 dark:bg-green-900/30' : exercise.difficulty === 'Intermediate' ? 'bg-yellow-100 dark:bg-yellow-900/30' : 'bg-red-100 dark:bg-red-900/30'}
            `} data-id="element-334">
              <BookIcon className={`
                w-5 h-5
                ${exercise.difficulty === 'Beginner' ? 'text-green-600 dark:text-green-400' : exercise.difficulty === 'Intermediate' ? 'text-yellow-600 dark:text-yellow-400' : 'text-red-600 dark:text-red-400'}
              `} data-id="element-335" />
            </div>
            <div data-id="element-336">
              <span className="text-sm font-medium text-gray-600 dark:text-gray-400" data-id="element-337">
                {isArabic ? exercise.difficultyAr : exercise.difficulty}
              </span>
              <span className="mx-2 text-gray-400" data-id="element-338">•</span>
              <span className="text-sm text-gray-500 dark:text-gray-400" data-id="element-339">
                {isArabic ? exercise.typeAr : exercise.type}
              </span>
            </div>
          </div>
          {exercise.isCompleted && <CheckCircleIcon className="w-5 h-5 text-green-500" data-id="element-340" />}
        </div>
        {/* Content */}
        <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2" data-id="element-341">
          {isArabic ? exercise.title.ar : exercise.title.en}
        </h3>
        <p className="text-gray-600 dark:text-gray-300 mb-4" data-id="element-342">
          {isArabic ? exercise.description.ar : exercise.description.en}
        </p>
        {/* Progress Bar */}
        {exercise.progress > 0 && <div className="mb-4" data-id="element-343">
            <div className="flex items-center justify-between text-sm text-gray-500 dark:text-gray-400 mb-1" data-id="element-344">
              <span data-id="element-345">{isArabic ? 'التقدم' : 'Progress'}</span>
              <span data-id="element-346">{exercise.progress}%</span>
            </div>
            <div className="h-2 bg-gray-100 dark:bg-gray-700 rounded-full overflow-hidden" data-id="element-347">
              <div className="h-full bg-blue-600 dark:bg-blue-400 transition-all duration-300" style={{
            width: `${exercise.progress}%`
          }} data-id="element-348" />
            </div>
          </div>}
        {/* Footer */}
        <div className="flex items-center justify-between" data-id="element-349">
          <div className="flex items-center gap-4 text-sm text-gray-500 dark:text-gray-400" data-id="element-350">
            <div className="flex items-center gap-1" data-id="element-351">
              <ClockIcon className="w-4 h-4" data-id="element-352" />
              <span data-id="element-353">
                {exercise.timeEstimate} {isArabic ? 'دقيقة' : 'mins'}
              </span>
            </div>
            <div data-id="element-354">
              {exercise.questions} {isArabic ? 'سؤال' : 'questions'}
            </div>
          </div>
          {exercise.streak && exercise.streak > 0 && <div className="flex items-center gap-1 text-yellow-600 dark:text-yellow-400" data-id="element-355">
              <TrophyIcon className="w-4 h-4" data-id="element-356" />
              <span className="text-sm font-medium" data-id="element-357">{exercise.streak}</span>
            </div>}
        </div>
        {/* Hover State Button */}
        <div className="h-0 opacity-0 group-hover:h-auto group-hover:opacity-100 group-hover:mt-4 transition-all duration-200 overflow-hidden" data-id="element-358">
          <button className="w-full bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition-colors flex items-center justify-center gap-2" data-id="element-359">
            <span data-id="element-360">{isArabic ? 'ابدأ التمرين' : 'Start Exercise'}</span>
          </button>
        </div>
      </div>
    </div>;
}